module.exports = "/_next/static/images/mobilelocation-monotone-f9090d9af4ad5f195619bed81b2b8473.svg";